import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useLanguageStore, useSessionStore, useSoulSelfStore } from '@darkchat/sdk'
import { retrieveSoul } from '@darkchat/sdk'
import { LoadingScreen } from '../components/LoadingScreen'
import { logger } from '@darkchat/sdk/utils/logger'

export function OAuthCallback() {
  const navigate = useNavigate()
  const { lang } = useParams<{ lang: string }>()
  const { language } = useLanguageStore()
  const { setSoulId, setSessionToken } = useSessionStore()
  const { setSoulSelf } = useSoulSelfStore()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // URLパラメータからtoken、soulId、errorを取得
        const params = new URLSearchParams(window.location.search)
        const token = params.get('token')
        const soulId = params.get('soulId')
        const errorParam = params.get('error')

        if (errorParam) {
          setError(errorParam)
          return
        }

        if (!token || !soulId) {
          setError(language === 'ja'
            ? '認証情報が取得できませんでした'
            : 'Authentication credentials not found'
          )
          return
        }

        // セッション情報を保存
        setSoulId(soulId)
        setSessionToken(token)

        // Soul情報を取得
        const soulSelf = await retrieveSoul(soulId, token)
        setSoulSelf(soulSelf)

        // チャット画面へ遷移
        navigate(`/${language}/abyss`)
      } catch (err) {
        logger.error('OAuth callback error:', err)
        setError(language === 'ja'
          ? '認証処理中にエラーが発生しました'
          : 'Authentication processing failed'
        )
      }
    }

    handleCallback()
  }, [language, navigate, setSoulId, setSessionToken, setSoulSelf])

  if (error) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-md w-full text-center"
        >
          <div className="mb-6 p-6 bg-red-900/20 border border-red-900/50 rounded">
            <h2 className="text-red-400 text-xl mb-2">
              {language === 'ja' ? '認証失敗' : 'Authentication Failed'}
            </h2>
            <p className="text-red-400/80 text-sm">{error}</p>
          </div>
          <button
            onClick={() => navigate(`/${language}`)}
            className="px-6 py-3 bg-gradient-to-b from-[#1a1a1a] to-[#0f0f0f] hover:from-[#2a2a2a] hover:to-[#1a1a1a] border border-[#8B0000]/30 hover:border-[#8B0000]/60 transition-all text-gray-400"
          >
            {language === 'ja' ? 'ログイン画面へ戻る' : 'Return to Login'}
          </button>
        </motion.div>
      </div>
    )
  }

  return (
    <LoadingScreen
      message={language === 'ja' ? '魂の契約を締結中...' : 'Binding thy soul to the pact...'}
    />
  )
}
